import { createAction } from 'redux-actions';
import getSubscriptionsStatus from 'ui-forms-editor-automation-lib/api/getSubscriptionsStatus';
import getDynoGuid from 'ui-forms-editor-automation-lib/selectors/dynoSelectors/getDynoGuid';
export const REQUEST_SUBSCRIPTIONS_STATUS = '@@lib/REQUEST_SUBSCRIPTIONS_STATUS';
export const RECEIVE_SUBSCRIPTIONS_STATUS = '@@lib/RECEIVE_SUBSCRIPTIONS_STATUS';
export const FAIL_GETTING_SUBSCRIPTIONS_STATUS = '@@lib/FAIL_GETTING_SUBSCRIPTIONS_STATUS';
const requestSubscriptionsStatus = createAction(REQUEST_SUBSCRIPTIONS_STATUS);
const receiveSubscriptionsStatus = createAction(RECEIVE_SUBSCRIPTIONS_STATUS);
const failGettingSubscriptionsStatus = createAction(FAIL_GETTING_SUBSCRIPTIONS_STATUS);
const fetchSubscriptionsStatus = () => (dispatch, getState) => {
  const state = getState();
  const dynoGuid = getDynoGuid(state);
  dispatch(requestSubscriptionsStatus());
  getSubscriptionsStatus(dynoGuid).then(subscriptions => {
    dispatch(receiveSubscriptionsStatus(subscriptions));
  }).catch(() => {
    dispatch(failGettingSubscriptionsStatus());
  });
  return undefined;
};
export default fetchSubscriptionsStatus;